/**
 * Archive page script
 *
 * @author HammersportMarketing
 */

import "../../sass/archive.scss";

const checkViewportForNewsletter = () => {
  if ($(window).width() > 768) {
    $("div.not-found-text").addClass("position-absolute");
    $("div.not-found-text").addClass("centered-transform");
  } else {
    $("div.not-found-text").removeClass("position-absolute");
    $("div.not-found-text").removeClass("centered-transform");
  }
};

$(function () {
  checkViewportForNewsletter();
});

$(window).on("resize", () => {
  checkViewportForNewsletter();
});
